// extracted by mini-css-extract-plugin
module.exports = {"bg":"_2HjkL","inlineContent":"_2S9ms","pageWrapper":"_2e6ps"};